
import { Component, OnInit, HostListener } from '@angular/core';
import { WindowRef } from '../../utils/window';
import { Router } from '@angular/router';
import { Subject ,  Observable ,  Subscription } from 'rxjs';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { AuthorizationService } from '../authorization/authorization.service';
import { FormGroup, Validators, FormControl, FormBuilder, AbstractControl, ValidationErrors, ValidatorFn, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateUtil } from '../../utils/translate-util';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
// import { RecaptchaLoaderService } from '../../utils/recaptchaLoader.service';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service'
import { HeaderComponent } from '../../furniture/header.component';
import { MatDialog } from '@angular/material/dialog';

import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';


declare var grecaptcha: any;
export enum CheckBoxType { 
    ENROLL_AUTOPAY, 
    ENROLL_EBILL,
    LATER, NONE 
};


@Component({
    selector: 'div.dtf-forgotUserpage',
    imports: [SharedTranslateModule,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatIconModule, MatTooltipModule, MatSortModule,
        MatNativeDateModule, MatDatepickerModule
    ],
    templateUrl: './forgotUser.component.html',
    providers: [WindowRef]
})


export class ForgotUserComponent implements OnInit {

    constructor(router: Router, window: WindowRef,
                public auth: AuthorizationService, private fb: FormBuilder,public translateUtil: TranslateUtil,
                public translate: TranslateService, 
                public dtfhomepageService: DTFHomepageService, public headerComponent: HeaderComponent, public dialog: MatDialog
                ) {
        this.router = router;
        this._window = window;
        this.contextPath = (this._window.nativeWindow as any).mbfs.contextPath;
        this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
        this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    }
    check_box_type = CheckBoxType;

  currentlyChecked: CheckBoxType;
    private _window: WindowRef;
    router: Router;
    public registration: any;
    isAuthenticated = false;
    ciamLoginUrl = '';
    contextPath = '';
    currentCountry: string;
    isCanadaPortal = false;
    isReset = false;
    hasUpperCase = false;
    hasLowerCase = false;
    loader=false;
    hasNumeric = false;
    hasMinimum = false;
    hasMaximum = false;
    userIDcheck = false;
    reentercheck = false;
    reenteremailcheck=false;
    hide = false;
    hide2 = false;
    forgotUser= false;
    optionExist =false;
    autopayExist=false;
    successExist =false;
    userblock =false;
    loginLoaded = true;
    enableEbillContinue = false;
    rendered: any;
    captchaToggle = true;
    isAuth = '';
    userId = '';
    customerNumber ='';
    contractNumber ='';
    emailAddress ='';
    password = '';
    repassword='';
    language = '';
    openLoginModal = false;
    serviceErrorOccurred = false;
    serviceErrorDesc = '';
    usUrl: string;
    caUrl: string;
    brandId: string;
    targetRedirect = '';
    registrationRedirect = '';
    baseUrl = '';
    logoutRedirect = '';
    classicRedirect = '';
    environment = '';
    siteKeyCaptcha = '';
    recaptchaResponse = '';
    private recaptchaURL = APP_CONSTANTS.recaptchaURL;
    contractRequest: any = {};
    accountRequest: any = {};
    ebillRequest: any ={};
    emailOffers = true;
    forgotForm: FormGroup;
    ciamReCaptchaForm: FormGroup;
    numAttempts = false;
    userActive= false;
    formValidationClasses = {
      'mbfs-error': true,
    };

    buildForm() {
      this.forgotForm = this.fb.group({
        emailAddress:[''],
        customerNumber:['']
      });
      this.ciamReCaptchaForm = this.fb.group({
        recaptchaResponseKey: [null, Validators.required]
    });
    }

    selectSiteKey() {
      this.environment = (this._window.nativeWindow as any).mbfs.environment;
      if (this.environment === 'local') {
       this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaLocal;
      } else if (this.environment === 'dev') {
        this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaDev;
      } else if (this.environment === 'stage') {
        this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaStage;
      } else if (this.environment === 'prod') {
        this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaProd;
      } else {
        this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaProd;
      }
    }

    ngOnInit() {
      this.translateUtil.setCountryAndLangFromUIProp();
      this.translateUtil.getCurrentCountry().subscribe(val => {
          this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
          this.currentCountry = val;
      });
      this.auth.cast.subscribe(data => (this.isAuthenticated = data));
      this.contextPath = (this._window.nativeWindow as any).mbfs.contextPath;
      this.language = (this._window.nativeWindow as any).mbfs.language;
      if(this.isCanadaPortal === true){
        this.brandId = '3';
      }
      else{
        this.brandId = '2';
      }
     sessionStorage.setItem('brandId',this.brandId);
      this.auth.isAuthenticated(); // Checks if user is authenticated
      let element:HTMLElement = document.getElementById('auto_trigger_forgot') as HTMLElement;
      element.click();
      // this.onClickLogin(this.e);
    }
    
    onClickForgot(e: Event): void {
      this.onClickCloseNewNav(e);
      this.buildForm();
      this.selectSiteKey(); // used to set Site key based on environment
          
      //build login form
      this.openLoginModal = true;
      this.forgotForm.get('emailAddress').setValidators(
        Validators.compose([Validators.required,
        Validators.minLength(12),
        Validators.maxLength(60),
        Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[\.]+[a-z]{2,4}$')])
      );
      this.forgotForm.get('customerNumber').setValidators(
        Validators.compose([Validators.required,
             Validators.minLength(10),
             Validators.maxLength(10)])
      );
      }



  closeCIAMModal(e: Event) {
    this.openLoginModal = false;
    this.numAttempts = false;
    this.userActive = false;
    this.forgotUser =false;
    this.reentercheck=false;
    this.isReset = false;
    this.optionExist =false;
    this.autopayExist =false;
    this.serviceErrorOccurred = false;
    this.userblock =false;
    this.enableEbillContinue = false;
    this.successExist = false;
    this.headerComponent.registrationClick = false;
  }
  
  // submitUserForm(e: Event) {
  //   if (!this.userForm.valid) {
  //     this.translate.get('Errors.userId_passwordMatch').subscribe((data:any)=> {
  //       this.serviceErrorDesc = data;
  //      });
  //     this.serviceErrorOccurred = true;
  //     setTimeout(() => {
  //       this.serviceErrorOccurred = false;
  //     }, 2000);  //2s
  //     return;
  //   }
  //   if (this.captchaToggle) {
  //   if (this.ciamReCaptchaForm.invalid) {
  //     this.translate.get('Errors.recaptcha').subscribe((data: any) => {
  //       this.serviceErrorDesc = data;
  //       return;
  //      });
  //   }
  //  }
  //   this.userId = this.userForm.get('userID').value;

  //   if (this.captchaToggle) {
  //   const userRequest = {
  //     userId : this.userId,
  //     recaptcha : this.recaptchaResponse
  //   };
  //   this.getUser(userRequest);
  //  } else {
  //   const userRequest = {
  //     userId : this.userId,
  //     recaptcha : 'false'
  //   };
  //   this.getUser(userRequest);
  //  }
  //  this.profileExist = true;
  // }
 
  selectCheckBox(targetType: CheckBoxType) {
    // If the checkbox was already checked, clear the currentlyChecked variable
    if(this.currentlyChecked === targetType) {
      this.enableEbillContinue = false;
      this.currentlyChecked = CheckBoxType.NONE;
      return;
    }

    this.currentlyChecked = targetType;
    if(targetType !=null){
      this.enableEbillContinue = true;
    }
  }

prepareForgotUser(event: Event){
  this.contractRequest = {};
  if (!this.forgotForm.valid) {
    this.translate.get('Errors.userId_passwordMatch').subscribe((data:any)=> {
      this.serviceErrorDesc = data;
      });
    this.serviceErrorOccurred = true;
    setTimeout(() => {
      this.serviceErrorOccurred = false;
    }, 2000);  //2sv
    return;
  }
  this.emailAddress = this.forgotForm.get('emailAddress').value;
  let customerNumber = this.forgotForm.get('customerNumber').value;
  let forgotRequest = {
    ccanId : customerNumber,
    email: this.emailAddress,
    language: this.language
  };
  this.loginLoaded = false; //Spinner enabler
  this.auth.forgotUserId(forgotRequest).subscribe(res => {
    this.loginLoaded = true; // Spinner enabler
    if (res.statusMessage === 'SUCCESS') {
      this.loginLoaded = false;
      // this.forgotUser = true;
      this.openDialog(1);
    } else {
      this.openDialog(2);
    }
    this.loginLoaded = true;
  });


}

onClickCloseNewNav(e: Event) {
  if (e instanceof Event) {
      e.preventDefault();
      e.stopPropagation();
  }
}

   openLogin(e: Event) {
    this.openLoginModal = false;
    this.forgotUser = false;
    this.isReset = false;
    this.serviceErrorOccurred = false;
    let redirect = '';
    this.translate.get('LoginModal.LoginRedirect').subscribe((data:any)=> {
      redirect= this.usUrl +  data;
     });
     window.location.href = redirect;
  }

  openRegistration(e: Event) {
    this.openLoginModal = false;
    this.forgotUser = false;
    this.isReset = false;
    this.serviceErrorOccurred = false;
    let redirect = '';
    this.translate.get('LoginModal.RegistrationRedirect').subscribe((data:any)=> {
      redirect= this.usUrl +  data;
     });
     window.location.href = redirect;
  }

  openDialog(num:any): void {
    sessionStorage.removeItem('forgotdialog');
    if(num===1){
      sessionStorage.setItem('forgotdialog', 'one');
    }
    if(num===2){
      sessionStorage.setItem('forgotdialog', 'two');
    }
    sessionStorage.setItem('forgotEmail', this.emailAddress);
      let dialogRef = this.dialog.open(ForgotUserPopupComponent, {
        maxWidth: '200vw',
        width: '600px',
        disableClose: true
      } );
      dialogRef.afterClosed().subscribe(result => {
      });
}
}


@Component({
    selector: 'div.dtf-forgotUserPopuppage',
    imports: [SharedTranslateModule],
    templateUrl: 'forgotUserDialog.component.html',
    providers: [WindowRef]
})
export class ForgotUserPopupComponent {
  usUrl: string;
  caUrl: string;
  forgotdialog: string;
  errorMessage: string;
  dbLoaded = false;
  filterActive = false;
  hideError = false;
  filter = false;
  statusMessage = "";
  rowCount = 0;
  value = '';
  emailAddress: string;

  constructor(router: Router, private dtfhomepageService: DTFHomepageService, private fb: FormBuilder, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil, public dialog: MatDialog

  ) {
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    this.forgotdialog = sessionStorage.getItem('forgotdialog');
    this.emailAddress = sessionStorage.getItem('forgotEmail');

     this.auth.cast3.subscribe((errorMessage:any)=> {
      this.errorMessage = errorMessage;
     });
  }

closeDialog(){
  this.dialog.closeAll();
}

registerRedirect(e: Event) {
    let redirect = '';
    this.translate.get('LoginModal.RegistrationRedirect').subscribe((data:any)=> {
      redirect= this.usUrl +  data;
     });
     window.location.href = redirect;
  }

  contactRedirect(e: Event) {
    let redirect = '';
    this.translate.get('LoginModal.ContactRedirect').subscribe((data:any)=> {
      redirect= this.usUrl +  data;
     });
     window.location.href = redirect;
  }

  homeRedirect(e: Event) {
    let redirect = '';
    this.translate.get('LoginModal.LoginRedirect').subscribe((data:any)=> {
      redirect= this.usUrl +  data;
     });
     window.location.href = redirect;
  }

}